import { render, staticRenderFns } from "./MenuNavBar.vue?vue&type=template&id=54eb310a&scoped=true&"
import script from "./MenuNavBar.vue?vue&type=script&lang=js&"
export * from "./MenuNavBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavBar.vue?vue&type=style&index=0&id=54eb310a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb310a",
  null
  
)

export default component.exports